module.exports = __webpack_public_path__ + "img/Menu-09.94fb794d.png";